import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from '../ui/alert-dialog';

interface Props {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Hapus',
  cancelLabel = 'Batal',
  destructive = true,
  loading = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o && !loading) onCancel(); }}>
      <AlertDialogContent className="bg-[#090D1A] border-white/10 text-white max-w-sm" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">{title}</AlertDialogTitle>
          {description && <AlertDialogDescription className="text-white/50">{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <button
            data-testid="confirm-dialog-cancel"
            onClick={onCancel}
            disabled={loading}
            className="border border-white/15 text-white/70 font-medium px-4 py-2 rounded-lg transition-colors hover:bg-white/5 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            data-testid="confirm-dialog-confirm"
            onClick={onConfirm}
            disabled={loading}
            className={`font-medium px-5 py-2 rounded-lg transition-colors disabled:opacity-50 flex items-center gap-2 ${
              destructive
                ? 'bg-red-500 text-white hover:bg-red-400'
                : 'bg-cyan-400 text-[#050914] hover:bg-cyan-300'
            }`}
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" strokeWidth={2} />}
            {confirmLabel}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
